var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_105761",
    "data-name": "Group 105761",
    transform: "translate(-1279 -267)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 24.5,
    cy: 24,
    rx: 24.5,
    ry: 24,
    transform: "translate(1279 267)",
    fill: "#29c6f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1288 272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106325",
    "data-name": "Path 106325",
    fill: "#ffffff",
    d: "M24.513,21.968l-1.241-4.323H20.29v3.89A2.161,2.161,0,0,1,18.129,23.7h-.865v-.865a3.026,3.026,0,0,0-1.011-2.252,1.509,1.509,0,0,0-.5-2.935H9.7a1.509,1.509,0,0,0-.722,2.836,5.619,5.619,0,0,0-2.952,4.945.432.432,0,0,0,.432.432h.865a3.89,3.89,0,0,0,7.781,0H20.29a3.89,3.89,0,1,0,4.223-3.89Zm-13.3,5.619a1.729,1.729,0,1,1,1.729-1.729A1.729,1.729,0,0,1,11.213,27.587Zm12.968,0a1.729,1.729,0,1,1,1.729-1.729A1.729,1.729,0,0,1,24.18,27.587Zm-3.89-14.7v3.458a.432.432,0,0,0,.432.432h3.026a1.3,1.3,0,0,0,1.3-1.3V13.755a1.3,1.3,0,0,0-1.3-1.3H20.722A.432.432,0,0,0,20.29,12.89ZM15.1,16.348V9.432A.432.432,0,0,0,14.671,9H3.432A.432.432,0,0,0,3,9.432v6.916a.432.432,0,0,0,.432.432H14.671A.432.432,0,0,0,15.1,16.348ZM8.619,11.187v-.458a.432.432,0,1,1,.865,0v.458A3.432,3.432,0,0,1,12.4,13.755H5.7a3.432,3.432,0,0,1,2.918-2.568Zm4.755,4.3H4.729v-.865h8.645Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.ba2054388890d57c9b5e22b962917694.svg";
export { ForwardRef as ReactComponent };